<div class="parent">
  <div class="item">
    <h1>403</h1> <br><br>
    <h2>Access Denied</h2>
    <p>You are not authorized to access this page</p>
    <hr />
    <p>Go back to <a (click)="previousPage()">previous Page</a></p>
  </div>
</div>
